import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';

const css = oxygenCss({
  root: {
    stroke: 'currentColor',
    verticalAlign: 'middle'
  }
});

class Gift extends Component {
  static propTypes = {
    className: PropTypes.string
  };
  render() {
    const { className, ...other } = this.props;
    return (
      <svg
        {...other}
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 18 18"
        version="1.1"
        className={classNames(className, css.root)}
      >
        <g
          fill="none"
          fillRule="evenodd"
          transform="translate(1, 1)"
          strokeWidth="1.45454545"
        >
          <polyline points="14.5454545 5.81818182 14.5454545 16 1.45454545 16 1.45454545 5.81818182" />
          <rect x="0" y="2.90909091" width="16" height="2.90909091" />
          <path d="M3.63636364,1.45454545 C3.63636364,0.650909091 4.28727273,0 5.09090909,0 C7.24218182,0 8,2.90909091 8,2.90909091 L5.09090909,2.90909091 C4.28727273,2.90909091 3.63636364,2.25818182 3.63636364,1.45454545 Z" />
          <path d="M12.3636364,1.45454545 C12.3636364,0.650909091 11.7127273,0 10.9090909,0 C8.75781818,0 8,2.90909091 8,2.90909091 L10.9090909,2.90909091 C11.7127273,2.90909091 12.3636364,2.25818182 12.3636364,1.45454545 Z" />
          <polyline points="9.45454545 2.90909091 9.45454545 16 6.54545455 16 6.54545455 2.90909091" />
        </g>
      </svg>
    );
  }
}

export default Gift;



// WEBPACK FOOTER //
// ./src/js/Cio/Assets/Gift.js